import React from "react";
const ScrollContext = React.createContext();

const { 
  Provider : ScrollContextProvider, 
  Consumer : ScrollContextConsumer 
} = ScrollContext;
export { ScrollContext, ScrollContextProvider, ScrollContextConsumer };